import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

export default function Hero() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 50);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="relative h-[88vh] min-h-[640px] w-full overflow-hidden">
      {/* Full-bleed background video */}
      <video
        src="https://public.readdy.ai/ai/video_res/019efdcb-13fd-7781-8e53-7f7ace9e9a00.mp4"
        autoPlay
        loop
        muted
        playsInline
        aria-label="Slow-made farmhouse interior at golden hour"
        title="Hearth & Heirloom — handmade Midwest home goods"
        className={`absolute inset-0 w-full h-full object-cover object-center transition-transform duration-[2000ms] ease-out ${
          loaded ? "scale-100" : "scale-110"
        }`}
      />
      {/* Dark gradient for legibility, light at top so navbar still floats */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/55" />

      {/* Content */}
      <div className="relative h-full w-full flex flex-col justify-end">
        <div className="px-4 md:px-10 lg:px-14 pb-16 md:pb-20 max-w-6xl">
          <p
            className={`text-background-50/80 text-xs md:text-sm tracking-[0.3em] uppercase mb-4 md:mb-5 transition-all duration-1000 ${
              loaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"
            }`}
          >
            Est. in the Midwest
          </p>
          <h1
            className={`font-heading text-background-50 text-5xl md:text-7xl lg:text-[88px] leading-[0.95] tracking-tight transition-all duration-1000 delay-150 ${
              loaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
            }`}
          >
            Made slow.
            <br />
            Kept long.
          </h1>
          <div
            className={`mt-8 md:mt-10 flex flex-wrap items-center gap-4 transition-all duration-1000 delay-300 ${
              loaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"
            }`}
          >
            <Link
              to="/#collections"
              className="inline-flex items-center gap-2 px-6 h-11 rounded-full bg-background-50 text-foreground-950 text-sm font-medium hover:bg-background-100 cursor-pointer whitespace-nowrap"
            >
              Shop the collection
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
            </Link>
            <Link
              to="/artisans"
              className="inline-flex items-center gap-2 px-6 h-11 rounded-full border border-background-50/50 text-background-50 text-sm hover:bg-background-50/10 cursor-pointer whitespace-nowrap"
            >
              The makers
            </Link>
          </div>
        </div>

        {/* Scroll cue */}
        <div className="absolute bottom-6 left-1/2 -translate-x-1/2 hidden md:flex flex-col items-center gap-2 text-background-50/80">
          <span className="text-[10px] tracking-[0.4em] uppercase">Scroll</span>
          <span className="block w-px h-8 bg-background-50/60 animate-pulse" />
        </div>
      </div>
    </section>
  );
}